import React, { ReactNode } from 'react'

interface PageProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const PageContainer : React.FC<PageProps> = ({children,className,style}) => {
    let thisstyle = {
        // borderRadius:'8px',
        // boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        // backgroundColor:'#ffffff',
        // overflow:'auto',
        // padding:'20px 24px',
        // width:'100%',
        // minHeight: 'calc(100vh - 160px)',
        // ...style
    }
  return (
    <div style={{...thisstyle}} className={className}>
      {children}
    </div>
  )
}

export default PageContainer
